module.exports = (require("./loaders/browser/import-polyfill")(require('./bundle-url').getBundleURL() + "Show.eb31181f.js")).then(() => parcelRequire('7ikgF'));